import { EASINGS, StateNode } from "@tldraw/editor";
import { Dragging } from "./childStates/Dragging.mjs";
import { Idle } from "./childStates/Idle.mjs";
import { OneFingerZooming } from "./childStates/OneFingerZooming.mjs";
import { Pointing } from "./childStates/Pointing.mjs";
class HandTool extends StateNode {
  static id = "hand";
  static initial = "idle";
  static isLockable = false;
  static children() {
    return [Idle, Pointing, Dragging, OneFingerZooming];
  }
  onDoubleClick(info) {
    switch (info.phase) {
      case "settle-down": {
        if (this.editor.getInstanceState().isCoarsePointer) {
          this.transition("one_finger_zooming", info);
        }
        break;
      }
      case "settle-up": {
        const currentScreenPoint = this.editor.inputs.getCurrentScreenPoint();
        this.editor.zoomIn(currentScreenPoint, {
          animation: { duration: 220, easing: EASINGS.easeOutQuint }
        });
        break;
      }
    }
  }
}
export {
  HandTool
};
//# sourceMappingURL=HandTool.mjs.map
